import e from "./generateUtilityClass.mjs";
import i from "./generateUtilityClasses.mjs";
function o(t) {
  return e("MuiMenu", t);
}
i("MuiMenu", ["root", "paper", "list"]);
export {
  o as getMenuUtilityClass
};
//# sourceMappingURL=menuClasses.mjs.map
